import Axios from "@/Axios";

class FollowupStatusService{

    async getFollowupStatus(data={}){
        console.log("in followupp status")
        return await Axios.get('wms.wms.api.followup_status.get_followup_status',{
            params:data
        })
    }
    async createFollowupStatus(data){
        return await Axios.post('wms.wms.api.followup_status.create_followup_status',data)
    }
    async deleteFollowupStatus(followup_status){
        const transformed_followup_status = followup_status.map(item => ({ name: item }));
        return await Axios.delete('wms.wms.api.followup_status.delete_followup_status',{data:{followup_status:transformed_followup_status}})
    }

}

export default new FollowupStatusService()